import { signal, computed } from '@angular/core';

export class UserStore {
  private constructor() {}

  static token = signal<string | null>(null);
  static userId = signal<number | null>(null);
  static username = signal<string | null>(null);
  static roles = signal<number[]>([]);
  static firstname = signal<string | null>(null);
  static lastname = signal<string | null>(null);
  static email = signal<string | null>(null);

  static set(token: string) {
    this.token.set(token);
    const decoded = this.decode(token);

    this.userId.set(+decoded.sub);
    this.username.set(decoded.username);
    this.roles.set(decoded.roles ? decoded.roles.split(',').map(Number) : []);
    this.firstname.set(decoded.firstname);
    this.lastname.set(decoded.lastname);
    this.email.set(decoded.email);
  }

  static clear() {
    this.token.set(null);
    this.userId.set(null);
    this.username.set(null);
    this.roles.set([]);
    this.firstname.set(null);
    this.lastname.set(null);
    this.email.set(null);
  }

  static reset(token: string) {
    this.token.set(token);
    const decoded = this.decode(token);
    this.userId.set(+decoded.sub);
    this.username = decoded.username;
    this.roles = decoded.roles?decoded.roles.split(',').map(Number) : [];
    this.firstname = decoded.firstname;
    this.lastname = decoded.lastname;
    this.email = decoded.email;
  }

  static hasRole(rolesToCheck: number[]): boolean {
    return rolesToCheck.some(r => this.roles().includes(r));
  }

  private static decode(token: string): any {
    try {
      const payload = atob(token.split('.')[1]);
      return JSON.parse(payload);
    } catch {
      return {};
    }
  }
}
